export default {
  settleSummary: {
    collapseTitle: {
      expenseTitle: '费用类',
      profitTitle: '利润类',
    },
    column: {
      productCategory: '产品类别',
      tradeType: '贸易类型',
      salesCount: '销售数量(KG)',
      incomeClass: '收入类',
      salesAmountWithoutTax: '不含税收入(元)',
      salesAmountWithTax: '含税销售金额(元)',
      costPool: '成本类',
      costAmountWithoutTax: '不含税成本(元)',
      costAmountWithTax: '含税成本(元)',
      maoriClass: '毛利类',
      profitAmount: '毛利(元)',
      projectCode: '项目名称',
      periodName: '结算周期',
      name: '类型',
      value: '金额',
      expenseAmount: '费用合计',
    },
    form: {
      profitAmount: '项目利润',
    },
    placeholder: {
      expenseEntity: '请选择费用主体',
      expenseType: '请选择费用类别',
      amountWithTax: '请输入含税金额',
      taxRate: '请选择税率',
      auto: '自动生成',
      name: '请输入类型',
      value: '请输入金额',
    },
    message: {
      noProject: '请选择项目名称！',
      noPeriod: '请选择结算周期！',
      noTradeType: '请选择贸易类型！',
      amountValid: '利润类合计金额不能超过项目利润金额！',
    },
  },
};
